module.exports = __webpack_public_path__ + "static/media/A steampunk metropolis floating in the clouds, powered by giant gears and steam engines.b1b11301.jpeg";